import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMediaObjectVideo16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconMediaObjectVideo16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3 3h5a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1M1 4a2 2 0 0 1 2-2h5a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm11 0a.5.5 0 0 0 0 1h2.5a.5.5 0 0 0 0-1zm-.5 3.5A.5.5 0 0 1 12 7h1.5a.5.5 0 0 1 0 1H12a.5.5 0 0 1-.5-.5M7.59 8.576a.75.75 0 0 0 0-1.152L5.23 5.458A.75.75 0 0 0 4 6.034v3.932a.75.75 0 0 0 1.23.576zM5 6.568 6.719 8 5 9.432z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMediaObjectVideo16);
